module.exports = __webpack_public_path__ + "img/jiniantang2.399a5d9e.png";